import $ from 'jquery';

import AlerterView from 'chairisher/view/alerter';

import { getQuickCreateUrl } from 'chairisher/context/auth';

/**
 * @class BusinessFollowView
 * @classdesc A view which encapsulates logic around following a business
 * @constructor
 */
const BusinessFollowView = function (settings) {
    settings = $.extend(
        {
            followedBusinessIds: this._followedBusinessIds,
        },
        settings,
    );

    this._followedBusinessIds = settings.followedBusinessIds;

    this._initializeFollowIcons();
    this._bind();
};

/**
 * CSS classes which can be applied to the follow icon.
 *
 * @enum {string}
 */
BusinessFollowView.IconClass = {
    FOLLOWED: 'cicon-heart-fill',
    NOT_FOLLOWED: 'cicon-heart-stroke',
};

/**
 * Selector for the follow icon.
 *
 * @type {string}
 * @default
 * @private
 */
BusinessFollowView.prototype._followIconSelector = '.js-follow-icon';

/**
 * List of business ids which are followed by the current user.
 *
 * @type {Array.<number>}
 * @private
 */
BusinessFollowView.prototype._followedBusinessIds = null;

/**
 * Bind actions for this view.
 *
 * @private
 */
BusinessFollowView.prototype._bind = function () {
    const businessIdToXHRMap = {};

    $('.js-business-follow').on(
        'click',
        $.proxy(function (e) {
            e.preventDefault();

            const $initiator = $(e.currentTarget);
            const businessId = $initiator.closest('.js-business').data('business-id');

            if (businessIdToXHRMap[businessId]) {
                return; // A request is already in flight.
            }

            $initiator.addClass('disabled');
            const isDeleteRequest = $.inArray(businessId, this._followedBusinessIds) !== -1;

            businessIdToXHRMap[businessId] = $.ajax({
                authUrl: getQuickCreateUrl('designer-follow'),
                method: isDeleteRequest ? 'delete' : 'post',
                url: $initiator.attr('href') || $initiator.data('url'),
            })
                .done(
                    $.proxy(function (data) {
                        if (isDeleteRequest) {
                            const index = $.inArray(businessId, this._followedBusinessIds);
                            this._followedBusinessIds.splice(index, 1);
                        } else {
                            this._followedBusinessIds.push(businessId);
                        }

                        AlerterView.success(data.messages[0].message);

                        this._toggleFollowIcon($initiator, !isDeleteRequest);
                    }, this),
                )
                .always(() => {
                    $initiator.removeClass('disabled');
                    delete businessIdToXHRMap[businessId]; // Mark request as finished
                });
        }, this),
    );
};

/**
 * Set the initial UI state for follow icons based on the list of followed businesses.
 *
 * @private
 */
BusinessFollowView.prototype._initializeFollowIcons = function () {
    const $businesses = $('.js-business');
    $.each(
        $businesses,
        $.proxy(function (i) {
            const $business = $businesses.eq(i);
            const businessId = $business.data('business-id');
            if ($.inArray(businessId, this._followedBusinessIds) !== -1) {
                this._toggleFollowIcon($business, true);
            }
        }, this),
    );
};

/**
 * Toggle a follow icon to indicate that a business is or is not followed.
 *
 * @param {jQuery} $el Element containing the icon.
 * @param {boolean} isFavorite Whether the business should be marked as followed.
 * @private
 */
BusinessFollowView.prototype._toggleFollowIcon = function ($el, isFavorite) {
    $el.find(this._followIconSelector)
        .toggleClass(BusinessFollowView.IconClass.FOLLOWED, isFavorite)
        .toggleClass(BusinessFollowView.IconClass.NOT_FOLLOWED, !isFavorite);
};

export default BusinessFollowView;
